import { Box, Button, Stack, Typography } from '@mui/material';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Iconify from '../../../fl-components/Iconify';
import DownloadFileContainer from '../../DownloadFileContainer';
import FileUploadContainer from '../../FileUploadContainer';

export default function TestUploadContainer({ selectedFile, setSelectedFile }) {
  const fileInput = useRef();
  return (
    <Box>
      <input
        type="file"
        accept="image/png, image/jpeg, .pdf"
        style={{ display: 'none' }}
        ref={fileInput}
        onChange={() => {
          setSelectedFile(fileInput.current.files[0]);
        }}
      />

      <Box mt={2}>
        <Typography variant="subtitle1" mt={4} mb={2}>
          Upload Your Solution
        </Typography>
        {selectedFile === null ? (
          <FileUploadContainer onFileChange={(e) => setSelectedFile(e)} />
        ) : (
          <div>
            <DownloadFileContainer title={selectedFile.name} />
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Button onClick={() => fileInput.current.click()}>
                <Iconify icon="wpf:edit" sx={{ marginRight: '5px' }} width={20} height={20} />
                Edit Solution
              </Button>
              <Button color="error" onClick={() => setSelectedFile(null)}>
                <Iconify
                  icon="material-symbols:delete-outline-rounded"
                  width={20}
                  height={20}
                  sx={{ marginRight: '5px' }}
                />
                Delete Solution
              </Button>
            </Stack>
          </div>
        )}
      </Box>
    </Box>
  );
}

TestUploadContainer.propTypes = {
  selectedFile: PropTypes.object,
  setSelectedFile: PropTypes.func
};
